import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';
import { YodaFontSize } from 'yoda-ui/yodaTheme';

export const GridListSelectStyle: SxProps<Theme> = {
  height: '30px',
  fontSize: YodaFontSize.small,
};
